import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import AppTwoSidebar from './AppTwoSidebar';
import reportWebVitals from './reportWebVitals';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <AppTwoSidebar />
  </React.StrictMode>
);

reportWebVitals();
